package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.viewinterop.HtmlElementView
import com.shepeliev.webrtckmp.AudioTrack
import com.shepeliev.webrtckmp.VideoTrack
import kotlinx.browser.document
import org.w3c.dom.HTMLVideoElement
import org.w3c.dom.mediacapture.MediaStream
import org.w3c.dom.mediacapture.MediaStreamTrack

/**
 * Compose web renderiza todo a un único canvas, así que el `<video>` se embebe como elemento DOM
 * posicionado sobre el canvas vía [HtmlElementView] (el interop oficial de Compose, que sincroniza
 * posición/tamaño/densidad con el layout; solo funciona con el entry point `ComposeViewport`).
 *
 * Nota: el preview local se mutea para evitar eco. El audio remoto se maneja aparte.
 */
@Composable
actual fun Video(
    videoTrack: VideoTrack,
    modifier: Modifier,
    audioTrack: AudioTrack?,
) {
    fun buildStream(): MediaStream = MediaStream().apply {
        addTrack(videoTrack.js.unsafeCast<MediaStreamTrack>())
    }

    HtmlElementView(
        factory = {
            (document.createElement("video") as HTMLVideoElement).apply {
                autoplay = true
                muted = true
                setAttribute("playsinline", "true")
                style.setProperty("object-fit", "contain")
                style.setProperty("background-color", "black")
                srcObject = buildStream()
            }
        },
        modifier = modifier,
        update = { video ->
            video.srcObject = buildStream()
        },
    )
}
